import React, {useState} from "react";
import {TextInputProps, TextInput, View, StyleSheet} from "react-native";
import Text from '../component/CustomTextComponent';
import { THEME_COLORS, FONT_FAMILY } from "../themes";

interface ICustomTextInputProps extends TextInputProps {
  label:string,
  error?:boolean,
  width?:number,
  height?:number,
  containerStyle?:any,
  isRequired?: boolean,
}

const CustomTextInput = (props: ICustomTextInputProps) => {

    const [focusStyle, setFocusStyle] = useState({});
    const { style, label, value, error, containerStyle, width, height, isRequired } = props;

    const passedStyle = Array.isArray(style) ? style : [style];
    const passedContainerStyle = containerStyle && Array.isArray(containerStyle) ? containerStyle : [containerStyle];
    const requiredAnnotation = isRequired ? "*" : "";

    return <View
            style={[
              styles.inputWidthHeight,
              ...passedContainerStyle ,
              /* {
                backgroundColor:error ? THEME_COLORS.lightPink : THEME_COLORS.grey2,
                width:width??250,
                height:height ?? 80,
                justifyContent:!value ? "center" :""
              } */
              ]}
            >
                    <Text fontSize={'medium'} style={{color:THEME_COLORS.textGrey}}>
                        {value ? label : ""}
                        <Text fontSize={'medium'} style={{color:THEME_COLORS.warning}}>{value ? requiredAnnotation : ""}</Text>
                    </Text>

                    <TextInput
                      {...props}
                      placeholder={!!props?.placeholder ? props?.placeholder + requiredAnnotation : ""}
                      onFocus={()=>setFocusStyle({outline:"none"})}
                      style={[{fontFamily:FONT_FAMILY.primary},styles.input,focusStyle, ...passedStyle]}
                    />
    </View>
}

const styles = StyleSheet.create({
  inputWidthHeight: {
    padding:5,
    // backgroundColor: THEME_COLORS.grey2,
    // borderRadius: 10,
    borderColor: '#fff',
    margin:5,
},
  input: {
    marginTop:"5%",
},

});

export default CustomTextInput;
